import { isNone } from '@ember/utils';
import FormCondition from 'cio/app-models/conditions/form';
import refinement from './refinement';
import { deserializeFilter as deserializeAttribute } from 'cio/utils/conditions/deserialize/attribute';
import deserializeAttributeCompare from 'cio/utils/conditions/deserialize/attribute-compare';
import FormEventAttributeCondition from 'cio/app-models/conditions/form-event-attribute';
import { deserializeFilters as deserializeEventFilters, filterOperator as eventFilterOperator } from './event';
import { SerializedFormCondition } from 'cio/types/conditions/condition';
import {
  SerializedLegacyAttributeFilter,
  SerializedLegacyAttributeFilters,
  SerializedLegacyAttributeFilterAnd,
} from 'cio/types/conditions/legacy-filter';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import GroupCondition from 'cio/app-models/conditions/group';
import { isGroupAndCondition, isGroupOrCondition, isSimpleCondition } from 'cio/utils/conditions/deserialize';

function filterToAttribute(filter: SerializedLegacyAttributeFilter) {
  if (filter.type === 'attribute_compare') {
    return deserializeAttributeCompare({ ...filter, event: 'form_submit' });
  }

  return deserializeAttribute({ ...filter, event: 'form_submit', type: 'event_attribute' });
}

export function deserializeFilters(
  tree?: SerializedLegacyAttributeFilters | Record<string, never>,
): (FormEventAttributeCondition | GroupCondition)[] {
  if (isNone(tree) || Object.keys(tree).length === 0) {
    return [];
  }

  if (isSimpleCondition(tree)) {
    return [filterToAttribute({ ...tree }) as FormEventAttributeCondition];
  }

  let group: SerializedLegacyAttributeFilters[] | null = null;
  if (isGroupAndCondition(tree)) {
    group = tree.and;
  } else if (isGroupOrCondition(tree)) {
    group = tree.or;
  }
  if (group) {
    return group.map((f: SerializedLegacyAttributeFilters) => {
      if (isSimpleCondition(f)) {
        return filterToAttribute(f) as FormEventAttributeCondition;
      }

      let operator: 'and' | 'or' = isGroupAndCondition(f) ? 'and' : 'or';
      return GroupCondition.create({
        operator,
        children: deserializeFilters(f),
      });
    });
  }

  return [];
}

export default function (json: SerializedFormCondition) {
  let { times, within, inverse, event } = json;

  if (isNone(times) && isNone(within)) {
    times = 1;
    within = 0;
  }

  let filters = event?.filters as SerializedLegacyAttributeFilterAnd | SerializedLegacyAttributeFilter;

  let formFilter = isGroupAndCondition(filters) ? filters.and.find((c) => c.form_type) : filters;
  let otherFilters = isGroupAndCondition(filters) ? filters.and.find((c) => !c.form_type) : null;

  return FormCondition.create({
    inverse,
    refinement: refinement(times, within),
    filters: otherFilters ? (deserializeEventFilters(otherFilters, 'form_submit') as EventAttributeCondition[]) : [],
    formFilter: (deserializeFilters(formFilter) as FormEventAttributeCondition[])[0],
    filterOperator: otherFilters ? eventFilterOperator(otherFilters) : 'and',
  });
}
